// extracted by mini-css-extract-plugin
export var deleteModal = "_pt-0";